import React from 'react'
import { LoaderCircle } from 'lucide-react'
import SpinnerStyled from './styled'
import PropTypes from 'prop-types'

const icon = ({ styledType }) => (
  <SpinnerStyled styledType={styledType}>
    <LoaderCircle size={40} />
  </SpinnerStyled>
)

icon.propTypes = {
  styledType: PropTypes.string
}

export default icon
